import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { fetchCart } from '../store/slices/cartSlice';

interface AppInitializerProps {
  children: React.ReactNode;
}

/**
 * Component that handles app-level initialization tasks like fetching cart data
 * when the user is authenticated.
 */
export default function AppInitializer({ children }: AppInitializerProps) {
  const dispatch = useDispatch<AppDispatch>();
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchCart());
    }
  }, [dispatch, isAuthenticated]);

  return <>{children}</>;
}
